
const digest = 'b8a73192b290a5b2a613945f760ca13c982f963b5a4198284ceafac46ccf3bff';
const css = `body {
  /**
   * Styling of buttons and other controls in this toolbar.
   * Note that toolbar, elementToolbar and selectionToolbar all use the same
   * components with different variable settings.
   * These are defined globally at the root so it can be accessed in the floating element toolbars
   */
  --editor-v2-toolbar-font-size: 13px;
  --aha-editor--user-line-height: 1.5;
  --editor-v2-toolbar-button-size: 24px;
  --editor-v2-toolbar-button-font-size: 14px;
  --editor-v2-toolbar-button-radius: 4px;
  --editor-v2-toolbar-button-color: var(--theme-primary-text);
  --editor-v2-toolbar-button-background-color: var(--theme-editor-button);

  --aha-editor-v2--background-color: var(--theme-primary-background);
  --aha-editor-v2--border-radius: var(--spacer-1);
  --aha-editor-v2--border-color: var(--theme-primary-border);
  --aha-editor-v2--border-hover-color: rgba(0, 115, 207, 0.2);
  --aha-editor-v2--border-width: 1px;
  --aha-editor-v2--focused-border-color: #88bbe4;
  --aha-editor-v2--focused-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 0 2px rgba(82, 168, 236, 0.5);
  --aha-editor-v2--selection-background-color: var(--rgb-gray-500);
  --aha-editor-v2--selection-outline-color: var(--rgb-gray-500);
  --aha-editor-v2--content-padding: 4px;
}

._wrapper_kmhx8_29 {
  display: flex;
  flex-direction: row;

  &._fullScreen_kmhx8_33 {
    position: fixed;
    left: 0;
    right: 0;
    /* 36px is the top bar height */
    top: var(--aha-editor--topbar-height) !important;
    height: calc(100% - var(--aha-editor--topbar-height));
    margin: 0;
    border: 0;
    overflow: hidden;
    box-shadow: none;
    z-index: 9998;
  }
}

._container_kmhx8_48 {
  --aha-editor-v2--monospace-fonts: Monaco, Menlo, Consolas, Courier New,
    monospace;

  position: relative;
  width: 100%;
  height: 100%;

  /* This is needed to prevent the editor container from taking up too much width in the flex row */
  min-width: 0;

  /* Styles for blurred editor. */
  &._blurred_kmhx8_60 {
    ._body_kmhx8_61 {
      /* Clicking on a link when not focused will navigate, so show the pointer */
      a[href] {
        cursor: pointer;
      }
    }
  }
}

.dark-mode-allowed[data-theme='dark'] ._container_kmhx8_48 {
  --aha-editor-v2--selection-background-color: var(--rgb-gray-600);
  --aha-editor-v2--selection-outline-color: var(--rgb-gray-600);
}

._showBorderNever_kmhx8_75 {
  --aha-editor-v2--border-color: transparent;
  --aha-editor-v2--border-hover-color: transparent;
  --aha-editor-v2--border-width: 0;
}

._showBorderFocused_kmhx8_81 {
  --aha-editor-v2--border-color: transparent;
}

._editor_kmhx8_85 {
  position: relative;
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-color: var(--aha-editor-v2--border-color);
  border-width: var(--aha-editor-v2--border-width);
  border-radius: var(--aha-editor-v2--border-radius);
  background-color: var(--aha-editor-v2--background-color);
}

._selections_kmhx8_96 {
  display: none;
  overflow: visible;
  position: relative;
}

._focused_kmhx8_102 {
  outline: none;
  text-decoration: none;

  ._selections_kmhx8_96 {
    display: block;
  }
}

/**
 * These '.focused' rules are below '.editor' so we can use cascading to override the above rules.
 */
._notFullScreen_kmhx8_114 {
  ._showBorderAlways_kmhx8_115,
  ._showBorderFocused_kmhx8_81 {
    &._focused_kmhx8_102 {
      ._editor_kmhx8_85 {
        --aha-editor-v2--border-color: var(
          --aha-editor-v2--focused-border-color
        );
        box-shadow: var(--aha-editor-v2--focused-box-shadow);
      }
    }
  }

  ._editor_kmhx8_85 {
    &:hover {
      --aha-editor-v2--border-color: var(--aha-editor-v2--border-hover-color);
    }
  }
}

._hiddenToolbar_kmhx8_134 {
  ._toolbar_kmhx8_135 {
    display: none;
  }

  &._focused_kmhx8_102 ._toolbar_kmhx8_135 {
    display: flex;
  }
}

._notFullScreen_kmhx8_114 ._inline_kmhx8_144 {
  ._toolbar_kmhx8_135 {
    visibility: hidden;
    margin-top: calc(-1 * var(--aha-editor--toolbar-height));
  }

  &._blurred_kmhx8_60 {
    ._anchor_kmhx8_151 {
      pointer-events: none;
    }
  }

  &._focused_kmhx8_102 {
    top: calc(-1 * var(--aha-editor--toolbar-height));
    margin-bottom: calc(-1 * var(--aha-editor--toolbar-height));

    ._toolbar_kmhx8_135 {
      visibility: visible;
      margin-top: 0;
    }
  }
}

._content_kmhx8_167 {
  flex: auto;
  flex-basis: 1px;
  padding: var(--aha-editor-v2--content-padding, var(--spacer-2));
  position: relative;
  z-index: 0;
}

._body_kmhx8_61 {
  min-height: var(--aha-editor-v2--body-min-height, unset);
  position: relative;
  transform-origin: left top;
  transform: var(--aha-editor--body-transform, initial);
}

._hasContent_kmhx8_182 {
  /* We only set this if there's content, otherwise these styles apply to the placeholder content, which is rendered in a single <p> */
  ._body_kmhx8_61 {
    > p:last-child {
      --default-type-margin: 0;
      /* This variable is used by .user-content for styling static content */
      --aha-editor--block-margin: 0;
    }
  }
}

._isEmpty_kmhx8_193 {
  ._body_kmhx8_61 {
    ._placeholder_kmhx8_195 {
      > p:last-child {
        --default-type-margin: 0;
        /* This variable is used by .user-content for styling static content */
        --aha-editor--block-margin: 0;
      }
    }
  }
}

._focused_kmhx8_102 {
  --aha-editor-v2--selection-background-color: var(--rgb-blue-200);
  --aha-editor-v2--selection-outline-color: var(--rgb-blue-400);
}

._placeholder_kmhx8_195 {
  font-family: var(--default-font-family);
  min-height: var(--aha-editor-v2--body-min-height, 1.5rem);
}

._fullScreen_kmhx8_33 {
  .aha-editor-field-v2__sidepanel {
    margin-top: calc(var(--aha-editor--toolbar-height) + 1px);
  }

  &:has(._readOnly_kmhx8_220) .aha-editor-field-v2__sidepanel {
    margin-top: 1px;
  }

  > ._container_kmhx8_48 {
    ._editor_kmhx8_85 {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      background-color: var(--theme-container-background);
    }

    ._content_kmhx8_167 {
      background-color: var(--aha-editor-v2--background-color);
      display: flex;
      flex-direction: column;
      margin: 50px;
      margin-top: calc(50px + var(--aha-editor--toolbar-height));
      padding: 75px 100px;
      box-shadow: var(--aha-editor-body-with-toc-box-shadow);
      flex: 1;
    }

    &._focused_kmhx8_102 {
      box-shadow: none;
      border-color: transparent;
    }
  }
}

._editable_kmhx8_250 {
  ._content_kmhx8_167 {
    /**
     * This might seem counter-intuitive, but a [contentEditable] is _always_ selectable.
     * The purpose of this CSS rule is prevent Slate from thinking content inside the '.container', but outside the '<Editable>', is selectable.
     * This fixes weird bugs where doing thngs like Cmd+A to select all text will seem to try and select OUTSIDE the editor content, thus leaving
     * an invalid selection range.
     *
     * Related bugs:
     *   - https://big.aha.io/develop/features/CREATE-2114
     *   - https://big.aha.io/develop/requirements/CREATE-1804-40
     *   - https://big.aha.io/features/ACT-1668
     *
     * Slate issue that gave me a hint to a solution:
     *   - https://github.com/ianstormtaylor/slate/issues/2500#issuecomment-471129827
     */
    user-select: none;
  }
}

/* Empty classes for now, used to flag readOnly/interactive behaviours in the DOM */
._readOnly_kmhx8_220 {
}

._interactive_kmhx8_274 {
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"wrapper":"_wrapper_kmhx8_29","fullScreen":"_fullScreen_kmhx8_33","container":"_container_kmhx8_48","blurred":"_blurred_kmhx8_60","body":"_body_kmhx8_61","showBorderNever":"_showBorderNever_kmhx8_75","showBorderFocused":"_showBorderFocused_kmhx8_81","editor":"_editor_kmhx8_85","selections":"_selections_kmhx8_96","focused":"_focused_kmhx8_102","notFullScreen":"_notFullScreen_kmhx8_114","showBorderAlways":"_showBorderAlways_kmhx8_115","hiddenToolbar":"_hiddenToolbar_kmhx8_134","toolbar":"_toolbar_kmhx8_135","inline":"_inline_kmhx8_144","anchor":"_anchor_kmhx8_151","content":"_content_kmhx8_167","hasContent":"_hasContent_kmhx8_182","isEmpty":"_isEmpty_kmhx8_193","placeholder":"_placeholder_kmhx8_195","readOnly":"_readOnly_kmhx8_220","editable":"_editable_kmhx8_250","interactive":"_interactive_kmhx8_274"};
export { css, digest };
  